import { limitsTransformer, LimitsType } from './limitsTransformer';
import { flagsTransformer, FlagsType } from './flagsTransformer';
import { transformMessages, MessagesType } from './transformMessages';


export interface VaultParamsType {
  available_payment_methods: [],
  currency_names: string,
  messages: MessagesType,
  offer_image: [],
  limits: LimitsType,
  flags: FlagsType,
  nykaa_rewards: [],
}

/**
 * @description
 * transformer for vault api vaultExtraParamsMap key
 * @param vaultParams - vault api params
 */
export const vaultParamsTransformer = (vaultParams:VaultParamsType) => {
  if (!vaultParams) {
    return {};
  }
  return {
    availablePaymentMethods: vaultParams.available_payment_methods,
    currencyNames: vaultParams.currency_names,
    messages: transformMessages(vaultParams.messages),
    offerImage: vaultParams.offer_image || [],
    limits: limitsTransformer(vaultParams.limits),
    flags: flagsTransformer(vaultParams.flags),
    nykaaRewards: vaultParams.nykaa_rewards,
  };
};
